import React, { Fragment, useContext, useEffect } from 'react';
import { Paper, Grid, Button, Typography, Link } from '@material-ui/core';
import { useStyles } from '../styles/Styles';
//Context API
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import DocumentItems from '../components/documents/DocumentItems';
import Header from '../components/header/Header';

const Upload = () => {
  const classes = useStyles(); //Use Styles from styles/styles.js
  const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
  const {
    userInfo,
    errors,
    notifications,
    clearErrors,
    clearNotifications,
    complianceDocuments,
    getComplianceDocuments,
    noOfUploadedDocs,
    noOfRequiredDocs,
    loading,
    deleteDocuments,
    delDocs,
    uploadDocuments,
  } = documentUploadContext;

  const notificationContext = useContext(NotificationContext);
  //Submit Form
  const handleSubmitClick = (e) => {
    e.preventDefault();
    deleteDocuments();
    //submitDocuments(userInfo.referenceNumber, userInfo.customerId);
  };
  //Initializes when page loads or updates
  useEffect(() => {
    if (notifications != null) {
      notificationContext.setNotification(notifications, 'success');
      clearNotifications();
    }
    if (errors != null) {
      notificationContext.setNotification(errors, 'error');
      clearErrors();
    }
    if (complianceDocuments == null) {
      console.log(1);
      getComplianceDocuments(userInfo.referenceNumber);
    } // eslint-disable-next-line
    // eslint-disable-line react-hooks/exhaustive-deps
    // eslint-disable-next-line
  }, []); // eslint-disable-next-line
  useEffect(() => {
    if (delDocs) {
      uploadDocuments();
    }

    // eslint-disable-next-line
  }, [delDocs]);

  return (
    <div>
      <Header page={4} />
      <div className={classes.banner}>
        <Fragment>
          <form onSubmit={handleSubmitClick}>
            <Typography className={classes.paragraph}>
              Please submit a clear copy of your additional requirements.
            </Typography>
            <Paper elevation={2} className={classes.paper}>
              {loading ? (
                <Spinner />
              ) : complianceDocuments !== null &&
                complianceDocuments.documents.length === 0 ? (
                <Fragment>
                  <div className={classes.documentContent}>
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        <Typography
                          color='textPrimary'
                          style={{ fontWeight: '700', fontSize: '14px' }}
                        >
                          You have no pending documents to submit. Thank you.
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                  <Grid
                    container
                    spacing={2}
                    direction='row'
                    justify='center'
                    alignItems='center'
                  >
                    <Grid item md={2}>
                      <Button
                        component={Link}
                        href={process.env.REACT_APP_URL}
                        style={{
                          textAlign: 'right',
                          textDecoration: 'none',
                          width: 'max-content',
                        }}
                        className={classes.button}
                        variant='contained'
                        color='primary'
                      >
                        Go Back to PSBank Online
                      </Button>
                    </Grid>
                  </Grid>
                </Fragment>
              ) : (
                <Fragment>
                  <Notification />
                  <div className={classes.documentContent}>
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        <Typography
                          color='textPrimary'
                          style={{ fontWeight: '700', fontSize: '14px' }}
                        >
                          Additional Requirements
                        </Typography>
                      </Grid>
                    </Grid>

                    {complianceDocuments != null ? (
                      <div>
                        {complianceDocuments.documents !== null ? (
                          complianceDocuments.documents
                            .sort((a, b) =>
                              a.description > b.description ? 1 : -1
                            )
                            .map((doc, index) => (
                              <DocumentItems
                                key={index}
                                doc={doc}
                                refNo={complianceDocuments.referenceNumber}
                              />
                            ))
                        ) : (
                          <Fragment></Fragment>
                        )}
                      </div>
                    ) : (
                      <Spinner />
                    )}
                  </div>
                  <br />
                  <Grid
                    container
                    spacing={2}
                    direction='row'
                    justify='center'
                    alignItems='center'
                  >
                    <Grid item md={2} />
                    <Grid
                      item
                      md={2}
                      style={{
                        display:
                          complianceDocuments === null ? 'none' : 'inline-block',
                      }}
                    >
                      {noOfUploadedDocs >= noOfRequiredDocs ? (
                        <Button
                          style={{
                            textAlign: 'right',
                            textTransform: 'capitalize',
                          }}
                          variant='contained'
                          className={classes.button}
                          color='primary'
                          type='submit'
                        >
                          Submit
                        </Button>
                      ) : (
                        <Button
                          style={{ textAlign: 'right' }}
                          className={classes.button}
                          variant='contained'
                          color='primary'
                          type='submit'
                          disabled
                        >
                          Submit
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Fragment>
              )}
            </Paper>
          </form>
        </Fragment>
      </div>
    </div>
  );
};
export default Upload;
